import type { CSSProperties } from 'react';

/** The crucible page a Character Home link or join opens. */
export function toCruciblePath(crucibleId: string): string {
    return `/crucibles/${encodeURIComponent(crucibleId)}`;
}

/** The style that tints a crucible card or panel with its accent (`--crucible-accent` in the SCSS). */
export function toCrucibleAccentStyle(accentColor: string): CSSProperties {
    return { '--crucible-accent': accentColor } as CSSProperties;
}
